import { FeatureType, Menu, MenuType } from './menu-item-shared';

const management: Menu = {
  state: 'management',
  name: 'menu.stations.management',
  type: MenuType.Static,
  icon: 'ev_station',
};

const loadManagement: Menu = {
  state: 'loadmanagement',
  name: 'menu.loadmanagement',
  icon: 'power',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.LoadManagement],
};

const ocpp: Menu = {
  state: 'ocpp',
  name: 'menu.stations.ocpp',
  type: MenuType.Static,
  icon: 'extension',
};

const qrCodes: Menu = {
  state: 'qrcode',
  name: 'menu.stations.qrcode',
  type: MenuType.Static,
  icon: 'qr_code',
};

const groups: Menu = {
  state: 'groups',
  name: 'menu.groups',
  type: MenuType.Static,
  icon: 'group',
};

const cardTerminals: Menu = {
  state: 'terminals',
  name: 'menu.stations.cardterminals',
  type: MenuType.Static,
  icon: 'point_of_sale',
  requiredFeatures: [FeatureType.CardTerminalsRollout],
};

export const stationsMenu: Menu = {
  state: 'stations',
  name: 'menu.stations',
  type: MenuType.Expandable,
  icon: 'ev_station',
  children: [management, loadManagement, ocpp, qrCodes, groups, cardTerminals],
};
